import { useContext } from "react";
import { TipContext } from "../../containers/TipContext";
import { champName, champPath } from "../misc/Static";
import styles from "./Champ.module.css";
import Tippy from "@tippyjs/react";

const Champ = ({ id, type }) => {
  const tips = useContext(TipContext);
  const name = champPath(id);
  const sizes = {
    champ20b: 20,
    champ24b: 30,
    champ28: 30,
    champ30b: 30,
    champ32b: 30,
    champ37br: 50,
    champ50b: 50,
  };
  const size = sizes[type];
  return (
    <>
      <Tippy
        content={
          <div
            className={tips.champ && tips.champ[id] ? "" : styles.loading}
            dangerouslySetInnerHTML={{
              __html:
                tips.champ && tips.champ[id] ? tips.champ[id] : "Loading...",
            }}
          />
        }
        onShow={() => {
          if (!tips.showChamp) tips.setShowChamp(true);
        }}
      >
        <img
          className={styles[type]}
          src={`https://cdn5.xdx.gg/champx${size}/${name}.webp`}
          srcSet={`https://cdn5.xdx.gg/champx${size}/${name}.webp ${size}w,
               https://cdn5.xdx.gg/champx${size * 2}/${name}.webp ${size * 2}w,
               ${
                 size < 50
                   ? `https://cdn5.xdx.gg/champx${size * 3}/${name}.webp ${
                       size * 3
                     }w,`
                   : ""
               }`}
          width={size}
          height={size}
          alt={champName(id)}
        />
      </Tippy>
    </>
  );
};

export default Champ;
